module.exports = __webpack_public_path__ + "static/img/14000540.b5769a53.png";